import React from "react";

export interface Step {
  label: any;
  value: CVEditStepType;
}

export enum CVEditStepType {
  Details = "Details",
  Experience = "Experience",
  Qualifications = "Qualifications",
  Documents = "Documents",
  QuestionForm = "QuestionForm",
  Application = "Application",
}

export interface StepsProps {
  steps: Step[];
  value: Step;
  onChange: (evt: React.MouseEvent<any, MouseEvent>, value: Step) => any;
  className?: string;
}
